import _extends from "@swc/helpers/src/_extends.mjs";
import React from 'react';
import { AdProviders, adunitMemo, ADUNIT_MAP } from '../constants';
import { useAdUnit } from '../useAdUnit';
const DesktopProfileBottomDisplay728x90 = /*#__PURE__*/ React.memo(({ safety ='unlikely'  })=>{
    const slotAttr = useAdUnit(AdProviders.Nitro, ADUNIT_MAP['DesktopProfileBottomDisplay728x90'], safety, {
        refreshLimit: 30,
        refreshTime: 30,
        renderVisibleOnly: false,
        refreshVisibleOnly: true,
        sizes: [
            [
                '728',
                '90'
            ],
            [
                '970',
                '90'
            ],
            [
                '970',
                '250'
            ]
        ],
        report: {
            enabled: false
        }
    });
    return /*#__PURE__*/ React.createElement("div", _extends({}, slotAttr));
}, adunitMemo);
DesktopProfileBottomDisplay728x90.displayName = 'DesktopProfileBottomDisplay728x90';
export default DesktopProfileBottomDisplay728x90;
